<script setup>
import { storeToRefs } from 'pinia';

import Button from '@/components/ds/Button.vue';
import Card from '@/components/ds/Card.vue';
import OteraMark from '@/components/ds/OteraMark.vue';
import { useAuthStore } from '@/stores/auth.js';

defineOptions({ name: 'MobileFallbackView' });

const auth = useAuthStore();
const { user } = storeToRefs(auth);

defineEmits(['logout']);
</script>

<template>
  <div class="centered-view">
    <Card class="centered-view__card">
      <div class="centered-view__brand">
        <OteraMark />
        <span>Otera</span>
      </div>
      <h1 class="centered-view__title">
        Best viewed on desktop.
      </h1>
      <p class="centered-view__copy">
        The dashboard is built for a desktop or laptop screen. Sign in from a
        wider display to access your data.
      </p>
      <div
        v-if="user"
        class="centered-view__actions"
      >
        <Button
          variant="secondary"
          icon-left="logout"
          @click="$emit('logout')"
        >
          Log out
        </Button>
      </div>
    </Card>
  </div>
</template>

<style scoped>
.centered-view {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  background: var(--bg-subtle);
}

.centered-view__card {
  max-width: 28rem;
}

.centered-view__brand {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-weight: var(--fw-semibold);
  color: var(--fg-primary);
  margin-bottom: var(--space-4);
}

.centered-view__title {
  font-size: var(--text-3xl);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-tight);
  margin: 0 0 var(--space-3);
  color: var(--fg-primary);
}

.centered-view__copy {
  font-size: var(--text-base);
  line-height: var(--lh-normal);
  color: var(--fg-secondary);
  margin: 0 0 var(--space-5);
}

.centered-view__actions {
  display: flex;
  justify-content: flex-end;
}
</style>
